// GENERATED FILE - do not edit.
// Emitted by tools/generate-wire-schemas.mjs from
// Server/src/Shared/Server/Resources/openapi.json (the spec lockfile).
// Regenerate with: npm run generate:wire
//
// Base wire shape for the server "QuestionResponse" component. The corresponding
// *.schema.ts is the facade that names it (and hosts any future refinement);
// see design/wiki/wire-schemas.md.
import { z } from "zod";
import { TreeItemType } from "./tree-item-type.enum.gen";

export const QuestionResponseGenShape = z.strictObject({
  text: z.string(),
  shortText: z.string().optional(),
  nextId: z.string().optional(),
  href: z.string().optional(),
  nextType: z.enum(TreeItemType),
});
